import { render } from "./ModalQnaProductOption.vue?vue&type=template&id=c5507d88&scoped=true"
import script from "./ModalQnaProductOption.vue?vue&type=script&lang=js"
export * from "./ModalQnaProductOption.vue?vue&type=script&lang=js"

import "./ModalQnaProductOption.vue?vue&type=style&index=0&id=c5507d88&scoped=true&lang=css"

import exportComponent from "/home/hosting_users/shoplus/custom/survey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5507d88"]])

export default __exports__